<div class="tlf_form_login" *ngIf="!loginSso">
  <form name="tlfForm" id="tlfForm" [formGroup]="loginForm" (ngSubmit)="onSubmitOld()">
    <img src="img/logo.png" alt="Teleforum logo" />

    <div class="formWrapper">
      <fieldset class="formRow">
        <legend class="sr-only">Username</legend>
        <div class="formRow--item">
          <label for="username" class="formRow--input-wrapper js-inputWrapper"
            [ngClass]="{'active': loginForm.getRawValue().username}">
            <span class="placeholder">Username</span>
            <span class="msg"
              *ngIf="loginForm.get('username').value && loginForm.get('username').invalid">{{msgErrorUsername}}</span>
          </label>
          <input autofocus type="text" id="username" autocomplete="on" name="username" formControlName="username"
            class="formRow--input js-input" placeholder="Username" />
        </div>
      </fieldset>

      <fieldset class="formRow">
        <legend class="sr-only">Password</legend>
        <div class="formRow&#45;&#45;item">
          <label for="password" class="formRow&#45;&#45;input-wrapper js-inputWrapper"
            [ngClass]="{'active': loginForm.getRawValue().password}">
            <span class="placeholder">Password</span>
          </label>
          <input type="password" id="password" autocomplete="off" name="password" formControlName="password"
            class="formRow&#45;&#45;input js-input" placeholder="Password" />
        </div>
      </fieldset>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <input type="submit" value="Accedi" name="accedi" id="accedi" [disabled]="loading || loginForm.invalid" />
      </div>
    </div>

    <div aria-live="assertive" class="alert alert-danger" *ngIf="loginForm.invalid">
      Username e password obbligatori
    </div>
    <!-- <a (click)="goSAML()" class="btn btn-primary">
      Accesso con SAML
    </a> -->
  </form>
</div>